/* eslint-disable  @typescript-eslint/no-explicit-any */
import React from 'react'; // we need this to make JSX compile
import { Logger } from '../../../../libs/utils/logger';
import { JointTenancySignUp } from './JointTenancySignUp';
import { Grid } from '@mui/material';
import { HeaderSignup } from '../HeaderSignup';
import { CustomerType } from '../../../../types/common.interfaces';

/**
 * Component: Signup join tenanct
 * Usage: User signup page
 */

Logger.debug("JointTenancySignUpWrapper.tsx", "Sign up joint tenancy initializing")

export const JointTenancySignUpWrapper: React.FC<any> = React.memo(() => {
         const source = {
        url: "/",
        method: "GET",
        data: {}
      } 
    return (
        <Grid item container xs={12}>
          <HeaderSignup percentage={60} logoutIconRequired={true} customerType={CustomerType.JOINT_TENANCY} />
          <Grid item xs={12}>
            <JointTenancySignUp source={source} id={"joint-tenancy-user-signup"}/> 
          </Grid>
        </Grid>
      );
    });
